export default "__VITE_ASSET__ClqJTVeL__"